import axios from 'axios';
import {rootUrl} from '@/common/js/config';
import md5 from 'js-md5';
import {httpGet,httpPost} from "@/common/js/util";

export function getRaskey () {
  const url = rootUrl.getRaskey
  // 根据视窗，动态计算一页显示的条数
  const params = {}
  return httpPost(url,params);
}

export function saveDeveloper (fm,modules,rsaMobile,email) {
  const url = rootUrl.saveDeveloper

  var companyName = fm.companyName.trim();
  var creditCode = fm.creditCode.trim();
  var city = fm.cityId;
  var province = fm.provinceId;
  var districtId = fm.districtId;
  var userName = fm.userName.trim();
  var mobilePhone = fm.mobilephone;
  var verification = fm.verification;
  var telephone = fm.specialTel.trim();
  var idCard = fm.idNumber.trim();
  var email = email;
  var businessPath = fm.businessPath;
  var qualificationPath = fm.qualificationPath;
  var qualificationId = fm.qualificationId;
  var qualificationName = fm.qualificationName;
  var sensitiveDataPath = fm.sensitiveDataPath;
  var sensitiveDataId = fm.sensitiveDataId;
  var sensitiveDataName = fm.sensitiveDataName;
  var appRegistrationPath = fm.appRegistrationPath;
  var appRegistrationId = fm.appRegistrationId;
  var appRegistrationName = fm.appRegistrationName;
  var recommandType = fm.recommandType;

  const params = {
    companyName: companyName,
    creditCode: creditCode,
    provinceId: province,
    cityId: city,
    districtId:districtId,
    userName: userName,
    mobilePhone: rsaMobile,
    verification: verification,
    telephone: telephone,
    idCard: idCard,
    email: email,
    modulus: modules,
    businessPath:businessPath,
    qualificationPath: qualificationPath,
    qualificationId: qualificationId,
    qualificationName: qualificationName,
    sensitiveDataPath: sensitiveDataPath,
    sensitiveDataId: sensitiveDataId,
    sensitiveDataName: sensitiveDataName,
    appRegistrationPath: appRegistrationPath,
    appRegistrationId: appRegistrationId,
    appRegistrationName: appRegistrationName,
    recommandType: recommandType,
  }

  return httpPost(url,params);
}

export function sendSMS(mobilephone,modules) {
  const url = rootUrl.sendSMS
  const params = {
    mobilephone: mobilephone,
    modulus:modules
  }

  return httpPost(url,params);
}

export function getProvince() {
  const url = rootUrl.getprovince
  const params = {}
  return httpPost(url,params);

}

export function getCityByProvince(provinceId) {
  const url = rootUrl.getCityByprovince
  const params = {
    provinceId: provinceId
  }

  return httpPost(url,params);

}

export function getDistrictByCiyt(cityId) {
  const url = rootUrl.getdistrictByCiyt
  const params = {
    cityId: cityId,
  }

  return httpPost(url,params);
}

export function selectByPrimaryKey() {
  const url = rootUrl.getUserInfo
  const params = {}
  return httpPost(url,params);
}

export function validateCodeEmail(email,code,modulus,step) {
  var url = rootUrl.validateCodeEmail;
  const  params = {
      emailAdress:email,
      code:code,
      modulus:modulus,
      step:step,
    }
  return httpPost(url,params);
}

export function getEmailCode (name) {
  var url = rootUrl.getEmailCode
  var name = name
  const  params = {
      'name': name,
    }
  return httpPost(url,params);
}

  export function getEmailCode2 (name,encrypedEmail,modulus) {
    var url = rootUrl.getEmailCodeNew
    var name = name
    var userName = encrypedEmail
    var modulus = modulus;
    const params ={
        'name':name,
        'userName':userName,
        'modulus' : modulus,
      }
    return httpPost(url,params);

  }

export function sendSMSNew(mobilephone,modules,step) {
  var url = rootUrl.sendSMSNew;
  const params = {
      mobilephone: mobilephone,
      modulus:modules,
      step:step,
    }
  return httpPost(url,params);
}

export function validateCodePhone(email,code,modulus,step) {
  var url = rootUrl.validateCodePhone;
  const  params= {
      emailAdress:email,
      code:code,
      modulus:modulus,
      step:step,
    }
  return httpPost(url,params);
}

export function updateDeveloper(oldPass,newPass,modules) {
  var url = rootUrl.updatDeveloporPass
   const params = {
     oldPass: oldPass,
     newPass: newPass,
     modules: modules,
   }
   return httpPost(url,params);
}

export function getDeveloperByLoginName(){
  const url = rootUrl.getDeveloperByLoginName
  const params = {}
  return httpPost(url,params);
}

export function developerModify(fm,modules,rsaMobile){
  const url = rootUrl.developerModify
  var companyName = fm.companyName.trim();
  var creditCode = fm.creditCode.trim();
  var city = fm.cityId;
  var province = fm.provinceId;
  var districtId = fm.districtId;
  var userName = fm.userName.trim();
  var mobilePhone = fm.mobilephone;
  var verification = fm.verification;
  var telephone = fm.specialTel.trim();
  var idCard = fm.idNumber.trim();
  var businessPath = fm.businessPath;
  var qualificationPath = fm.qualificationPath;
  var qualificationId = fm.qualificationId;
  var qualificationName = fm.qualificationName;
  var sensitiveDataPath = fm.sensitiveDataPath;
  var sensitiveDataId = fm.sensitiveDataId;
  var sensitiveDataName = fm.sensitiveDataName;
  var appRegistrationPath = fm.appRegistrationPath;
  var appRegistrationId = fm.appRegistrationId;
  var appRegistrationName = fm.appRegistrationName;
  var recommendType = fm.recommendType;

  const params = {
    companyName: companyName,
    creditCode: creditCode,
    provinceId: province,
    cityId: city,
    districtId:districtId,
    userName: userName,
    mobilePhone: rsaMobile,
    verification: verification,
    telephone: telephone,
    idCard: idCard,
    modulus: modules,
    businessPath:businessPath,
    qualificationPath: qualificationPath,
    qualificationId: qualificationId,
    qualificationName: qualificationName,
    sensitiveDataPath: sensitiveDataPath,
    sensitiveDataId: sensitiveDataId,
    sensitiveDataName: sensitiveDataName,
    appRegistrationPath: appRegistrationPath,
    appRegistrationId: appRegistrationId,
    appRegistrationName: appRegistrationName,
    recommandType: recommendType,
  }
  return httpPost(url,params);
}



// WEBPACK FOOTER //
// ./src/api/developer/developer-api.js